import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantCareers = (id, page = 1) => useQuery({ queryKey: [`${id}-careers`, page], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/careers?page=${page}`)
    return callback?.data
}})

export default useConsultantCareers